var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"avatar",class:{
    light: _vm.light,
    icon: _vm.imageError || (!_vm.imgName && !_vm.extImg),
  }},[(!_vm.imageError && (_vm.imgName || _vm.extImg))?_c('img',{staticClass:"image",attrs:{"src":_vm.extImg || require(`../../assets/media/avatars/${_vm.imgName}`),"alt":_vm.$t('general.alt-avatar-du-compte')},on:{"error":function($event){_vm.imageError = true}}}):_c('UilUser'),(_vm.notification > -1)?_c('Counter',{attrs:{"value":_vm.notification,"size":"small"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }